module.exports = __webpack_public_path__ + "img/collection-engagementRingsRedgold.151a3a0.jpg";